import React, { useCallback, useState } from "react";
import { Box, Link, Typography } from "@mui/material";
import { MdOutlineLock } from "react-icons/md";
import {
  StyledBox,
  StyledButton,
  StyledContainer,
  StyledInput,
  StyledRoot,
} from "./auth.styled";
import { LoginUserParams } from "../../../api/auth-request";
import { useLoginUser } from "../../../api-hooks/use-login-user";
import { AiOutlineUser } from "react-icons/ai";

type LoginProps = {
  handleRegister: () => void;
};

const Login: React.FC<LoginProps> = ({ handleRegister }) => {
  const [user, setUser] = useState<LoginUserParams>({
    username: "",
    password: "",
  });

  const { mutate, isPending } = useLoginUser();

  const handleDataChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setUser((prev) => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    },
    [],
  );

  const handleLogin = useCallback(() => {
    if (!isPending) mutate(user);
  }, [isPending, mutate, user]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") handleLogin();
    },
    [handleLogin],
  );

  return (
    <StyledContainer>
      <StyledRoot>
        <Typography fontWeight="bold" variant="h5">
          Welcome Back
        </Typography>
        <Box sx={{ marginTop: "0.5rem" }}>
          <Typography component="span">Don't have an account yet?</Typography>
          <Link
            sx={{ cursor: "pointer", marginLeft: "0.3rem" }}
            onClick={handleRegister}
          >
            Sign Up
          </Link>
        </Box>
        <StyledBox>
          <AiOutlineUser />
          <StyledInput
            name="username"
            placeholder="Username"
            onChange={handleDataChange}
            onKeyDown={handleKeyDown}
          />
        </StyledBox>
        <StyledBox>
          <MdOutlineLock />
          <StyledInput
            name="password"
            placeholder="Password"
            type="password"
            onChange={handleDataChange}
            onKeyDown={handleKeyDown}
          />
        </StyledBox>
        <StyledButton onClick={handleLogin}>Login</StyledButton>
      </StyledRoot>
    </StyledContainer>
  );
};

export default Login;
